import type { ReactNode } from 'react'
import type { FieldValues, Path, UseFormReturn } from 'react-hook-form'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'

interface AgentNodeRoleDescriptionSectionProps<T extends FieldValues> {
  form: UseFormReturn<T>
}

const ROLE_DESCRIPTION_MAX_LENGTH = 500

export const AgentNodeRoleDescriptionSection = <T extends FieldValues>({
  form,
}: AgentNodeRoleDescriptionSectionProps<T>): ReactNode => (
  <FormField
    control={form.control}
    name={'roleDescription' as Path<T>}
    render={({ field }) => (
      <FormItem>
        <FormLabel>Role Description</FormLabel>
        <FormControl>
          <Textarea
            placeholder="E.g., Senior Content Strategist responsible for brand voice..."
            className="agent-node-role-description-input resize-none"
            rows={3}
            maxLength={ROLE_DESCRIPTION_MAX_LENGTH}
            {...field}
          />
        </FormControl>
        <FormDescription>
          This is a master prompt add-on being passed to every agent node in the system
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
)

AgentNodeRoleDescriptionSection.displayName = 'AgentNodeRoleDescriptionSection'
